<template>
  <div class="firesafe" id="wrapper-box">
    <div class="px-5" id="wrapper">
      <nav class="breadcrumb px-0 mb-0">
        <router-link class="breadcrumb-item" to="/">Home</router-link>
        <span class="breadcrumb-item active">Firesafe</span>
      </nav>
      <p>Assessing fire safety in ro-ro passenger ships</p>
      <div id="firesafe-tabs">
        <span
          class="firesafe-1-tab transition scale-effect"
          href="#"
          v-bind:class="{ active: firesafe === 1 }"
          v-on:click="firesafeToggle(1)"
          >FIRESAFE I</span
        >
        <router-link
          class="info-ships-circle transition scale-effect"
          tag="span"
          to="/ship-info"
          ><img src="assets/img/ship_icon.png" /><span
            >SHIP INFO</span
          ></router-link
        >
        <span
          class="firesafe-2-tab transition scale-effect"
          v-bind:class="{ active: firesafe === 2 }"
          v-on:click="firesafeToggle(2)"
          >FIRESAFE II</span
        >
      </div>
      <div
        :class="[
          'hover-' + hover,
          { 'firesafe-1': firesafe === 1, 'firesafe-2': firesafe === 2 }
        ]"
        id="circles-menu"
      >
        <div class="d-flex justify-content-center align-items-center">
          <div
            @mouseleave="hover = 0"
            @mouseover="firesafe === 1 ? (hover = 1) : ''"
            class="circle-item circle-1 animated bounceIn"
            style="animation-delay: 0.5s"
            v-on:click="pushState(1, 1)"
          >
            <div
              class="circle d-flex justify-content-center align-items-center"
            >
              <span class="number">1</span>
              <img class="icon" src="assets/img/icon_ignition.png" />
              <div class="hover-txt">
                <p class="mb-1">
                  {{ data["IGNITION"].Short }}
                </p>
                <img src="assets/img/icon_open.png" />
                <router-link
                  class="more-btn"
                  tag="span"
                  to="/firesafe-1/ignition"
                  >MORE
                </router-link>
              </div>
            </div>
            <span>IGNITION</span>
          </div>
          <div
            @mouseleave="hover = 0"
            @mouseover="firesafe === 2 ? (hover = 1) : ''"
            class="circle-item circle-2 animated bounceIn"
            style="animation-delay: 0.6s"
            v-on:click="pushState(2, 1)"
          >
            <div
              class="circle d-flex justify-content-center align-items-center"
            >
              <span class="number">2</span>
              <img
                class="icon"
                src="assets/img/icon_detection.png"
                style="height:40px;"
              />
              <div class="hover-txt">
                <p class="mb-1">
                  {{ data["DETECTION"].Short }}
                </p>
                <img src="assets/img/icon_open.png" />
                <router-link
                  class="more-btn"
                  tag="span"
                  to="/firesafe-2/detection"
                  >MORE
                </router-link>
              </div>
            </div>
            <span>DETECTION</span>
          </div>
          <div
            @mouseleave="hover = 0"
            @mouseover="firesafe === 2 ? (hover = 2) : ''"
            class="circle-item circle-3 animated bounceIn"
            style="animation-delay: 0.7s"
            v-on:click="pushState(2, 2)"
          >
            <div
              class="circle d-flex justify-content-center align-items-center"
            >
              <span class="number">3</span>
              <img
                class="icon"
                src="assets/img/icon_decision.png"
                style="height:37px;"
              />
              <div class="hover-txt">
                <p class="mb-1">
                  {{ data["DECISION"].Short }}
                </p>
                <img src="assets/img/icon_open.png" />
                <router-link
                  class="more-btn"
                  tag="span"
                  to="/firesafe-2/decision"
                  >MORE
                </router-link>
              </div>
            </div>
            <span>DECISION</span>
          </div>
          <div
            @mouseleave="hover = 0"
            @mouseover="firesafe === 1 ? (hover = 2) : ''"
            class="circle-item circle-4 animated bounceIn"
            style="animation-delay: 0.8s  "
            v-on:click="pushState(1, 2)"
          >
            <div
              class="circle d-flex justify-content-center align-items-center"
            >
              <span class="number">4</span>
              <img class="icon" src="assets/img/icon_extinguishment.png" />
              <div class="hover-txt">
                <p class="mb-1">
                  {{ data["EXTINGUISHMENT"].Short }}
                </p>
                <img src="assets/img/icon_open.png" />
                <router-link
                  class="more-btn"
                  tag="span"
                  to="/firesafe-1/extinguishment"
                  >MORE
                </router-link>
              </div>
            </div>
            <span>EXTINGUISHMENT</span>
          </div>
          <div
            @mouseleave="hover = 0"
            @mouseover="firesafe === 2 ? (hover = 3) : ''"
            class="circle-item circle-5 animated bounceIn"
            style="animation-delay: 0.9s"
            v-on:click="pushState(2, 3)"
          >
            <div
              class="circle d-flex justify-content-center align-items-center"
            >
              <span class="number">5</span>
              <img
                class="icon"
                src="assets/img/icon_containment.png"
                style="height:40px;"
              />
              <div class="hover-txt">
                <p class="mb-1">
                  {{ data["CONTAINMENT"].Short }}
                </p>
                <img src="assets/img/icon_open.png" />
                <router-link
                  class="more-btn"
                  tag="span"
                  to="/firesafe-2/containment"
                  >MORE
                </router-link>
              </div>
            </div>
            <span>CONTAINMENT</span>
          </div>
          <div
            @mouseleave="hover = 0"
            @mouseover="firesafe === 2 ? (hover = 4) : ''"
            class="circle-item circle-6 animated bounceIn mr-0"
            style="animation-delay: 1s"
            v-on:click="pushState(2, 4)"
          >
            <div
              class="circle d-flex justify-content-center align-items-center"
            >
              <span class="number">6</span>
              <img
                class="icon"
                src="assets/img/icon_evacuation.png"
                style="height:40px; margin-left:7px"
              />
              <div class="hover-txt">
                <p class="mb-1">
                  {{ data["EVACUATION"].Short }}
                </p>
                <img src="assets/img/icon_open.png" />
                <router-link
                  class="more-btn"
                  tag="span"
                  to="/firesafe-2/evacuation"
                  >MORE
                </router-link>
              </div>
            </div>
            <span>EVACUATION</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import emsaJson from "../../data.json";

export default {
  name: "FiresafeSelector",
  props: {
    msg: String
  },
  data: function() {
    return {
      firesafe: 0,
      hover: 0,
      data: emsaJson
    };
  },
  computed: {
    getType() {
      return this.$route.params.type.toUpperCase();
    }
  },
  mounted: function() {
    //Vuex mutations
    this.$store.commit("setBackground", "blue-background");
    this.$store.commit("toggleShip", false);
    this.$store.commit("toggleWaves", true);
    this.$store.commit("toggleExpand", false);
    this.$store.commit("toggleFadeInDown", true);
    let self = this;
    setTimeout(function() {
      self.resetTransform();
    }, 2300);
  },
  methods: {
    firesafeToggle: function(number) {
      this.firesafe = number;
    },
    pushState: function(firesafe, item) {
      this.firesafe = firesafe;
      this.hover = item;
    },
    resetTransform: function() {
      let els = document.querySelectorAll(".circle-item");
      for (let i = 0; i < els.length; i++) {
        els[i].classList.remove("animated", "bounceIn");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>
